"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoundIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const SoundIcon_svg_1 = __importDefault(require("./SoundIcon.svg"));
/**
 * Centered play icon for media players
 */
function SoundIcon() {
    return (0, jsx_runtime_1.jsx)(SoundIcon_svg_1.default, {});
}
exports.SoundIcon = SoundIcon;
//# sourceMappingURL=SoundIcon.js.map